<script>
export default {
	name: 'IconSvgVector',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null,
		},
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		},
	},
}
</script>

<template>
	<div>
		<svg width="34" :height="size" viewBox="0 0 34 26" fill="white" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M1.66666 19L9.92107 10.7456C11.327 9.33969 13.6064 9.3397 15.0122 10.7456L23.2667 19M20.8667 16.6L23.1211 14.3456C24.527 12.9397 26.8064 12.9397 28.2122 14.3456L32.8667 19M4.06666 25H30.4667C31.7921 25 32.8667 23.9255 32.8667 22.6V3.4C32.8667 2.07452 31.7921 1 30.4667 1H4.06666C2.74117 1 1.66666 2.07452 1.66666 3.4V22.6C1.66666 23.9255 2.74117 25 4.06666 25ZM20.8667 7H20.8787V7.012H20.8667V7ZM21.4667 7C21.4667 7.33137 21.198 7.6 20.8667 7.6C20.5353 7.6 20.2667 7.33137 20.2667 7C20.2667 6.66863 20.5353 6.4 20.8667 6.4C21.198 6.4 21.4667 6.66863 21.4667 7Z"
				:stroke="color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
		</svg>

	</div>
</template>

<style scoped>

</style>